<template>
  <div class="ws-chip" :class="[color, { rectangle }]">
    <i v-if="leadingIcon" class="ws-chip__icon" :class="leadingIcon" />
    <img v-if="leadingImg" :src="leadingImg" alt="" class="ws-chip__img" />
    <p v-if="text" class="ws-chip__text" :class="{ wrap: isWrap, bold }">
      {{ $t(text) }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'WsChip001',
  props: {
    leadingIcon: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    leadingImg: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    isWrap: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    rectangle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
